import { render, staticRenderFns } from "./CampaignManage.vue?vue&type=template&id=5c81b730&"
import script from "./CampaignManage.vue?vue&type=script&lang=js&"
export * from "./CampaignManage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports